import { IconButton, Tooltip } from "@bvhi/ui-base";
import { DownloadIcon } from "@bvhi/ui-icons";
import { useTranslation } from "react-i18next";

interface Props {
  handleDownload: () => void;
  disabled: boolean;
}

export function DownloadCell({ handleDownload, disabled }: Props) {
  const { t } = useTranslation(["common"]);

  return (
    <Tooltip title={disabled ? t("common:button.tooltip.download.disabled") : t("common:button.tooltip.download.enabled")}>
      <span>
        <IconButton color="primary" disabled={disabled} onClick={handleDownload}>
          <DownloadIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
}
